const RANDOM_ROOM_ID = 50;

export const checkIsRandomRoom = (id: number): boolean => id === RANDOM_ROOM_ID;
